import { useMemo } from 'react';
import Button from 'epn-ui/umd/dist/components/Button';
import useI18n from '@i18n';

import apiHooks, { ICreateUseRequestInfiniteResponse } from '@apiHooks/index';
import { IGetOffersDataFormatted } from '@api/types';
import { IConfirmationStepProps } from '../interfaces';
import ConfirmPlacement from './ConfirmPlacement';
import PlacementOffers from './PlacementOffers';
import { ALI_ID, OFFERS_LIMIT, SOCIAL_CATEGORY_ID, WEBSITE_CATEGORY_ID } from '../constants';

const { useOffers } = apiHooks;

const ConfirmationStep: React.FC<IConfirmationStepProps> = ({
    afterReg,
    formData,
    createInProgress,
    onSubmit,
    onBack,
}) => {
    const { t, locale } = useI18n('Placements');
    const isSocialOrWebsite: boolean = useMemo(
        () =>
            +formData?.trafficSourceCategory === SOCIAL_CATEGORY_ID ||
            +formData?.trafficSourceCategory === WEBSITE_CATEGORY_ID,
        [formData],
    );

    const { data: offersData = [], meta, isLoading: isLoadingOffers, nextPage } = useOffers({
        params: {
            limit: OFFERS_LIMIT,
            lang: locale,
            viewRules: 'role_user',
            order: 'webmasterPriority',
            fields: 'id,image,webmasterMaxRate,webmasterRateSymbol,confirm',
            trafficSources: formData?.trafficSource,
        },
        dependencies: [locale],
    }) as ICreateUseRequestInfiniteResponse<IGetOffersDataFormatted[]>;

    return (
        <div className="mb-20 min-h-[400px]">
            {isSocialOrWebsite && (
                <ConfirmPlacement
                    formData={formData}
                    createInProgress={createInProgress}
                    onSubmit={() => onSubmit({ ...formData, offer: formData?.offer || ALI_ID })}
                    onBack={onBack}
                />
            )}

            <PlacementOffers
                formData={formData}
                isSocialOrWebsite={isSocialOrWebsite}
                offers={offersData}
                isLoadingOffers={isLoadingOffers}
                totalOffers={meta?.count}
                onNextOffers={nextPage}
            />

            {!isSocialOrWebsite && !afterReg && (
                <Button
                    type="primary"
                    className="w-full mt-6  xs:w-auto"
                    loading={createInProgress}
                    onClick={() => onSubmit({ ...formData, offer: ALI_ID })}
                >
                    {t('Submit for review')}
                </Button>
            )}
        </div>
    );
};

export default ConfirmationStep;
